import React from 'react';

const AboutImg = () => {
    return (
        <div className="wrapper">
            <div className="img-size-1">
                <div className="img object-fit">
                    <div className="object-fit-cover">
                        <img src="assets/img/placeholder/1600x800.jpg" alt="Team" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutImg;
